// extracted by mini-css-extract-plugin
module.exports = {"box":"SignDialog_box_3zQP3","content":"SignDialog_content_37t54","bg":"SignDialog_bg_2Awbr","btn":"SignDialog_btn_vy-W9","close":"SignDialog_close_2JXmO"};